import {
    SET_SOLAR_SYSTEM_SIZE,
    SET_SOLAR_PRODUCTION_RATIO,
    SET_SOLAR_VALUE,
    SET_SOLAR_ANNUAL_DEG,
    SET_SYSTEM_PRICE,
    SET_INSTALL_TYPE,
    SET_INSTALL_TYPE2,
    SET_INVERTER,
    SET_SOLAR_PANEL,
    SET_SYSTEM_NOTES,
    SET_SOLAR_INPUTS,
} from './constants';

export const setSolarInputs = solar => ({
    type: SET_SOLAR_INPUTS,
    solar,
});
export const setSolarSystemSize = systemSize => ({
    type: SET_SOLAR_SYSTEM_SIZE,
    systemSize,
});

export const setSolarProductionRatio = productionRatio => ({
    type: SET_SOLAR_PRODUCTION_RATIO,
    productionRatio,
});

export const setSolarValue = solarValue => ({
    type: SET_SOLAR_VALUE,
    solarValue,
});

export const setSolarAnnualDeg = annualDeg => ({
    type: SET_SOLAR_ANNUAL_DEG,
    annualDeg,
});

export const setSystemPrice = cashprice => ({
    type: SET_SYSTEM_PRICE,
    cashprice,
});

export const setInstallType = installType => ({
    type: SET_INSTALL_TYPE,
    installType,
});

export const setInstallType2 = installType2 => ({
    type: SET_INSTALL_TYPE2,
    installType2,
});

export const setInverter = inverter => ({
    type: SET_INVERTER,
    inverter,
});

export const setSolarPanel = solarPanel => ({
    type: SET_SOLAR_PANEL,
    solarPanel,
});

export const setSystemNotes = systemNotes => ({
    type: SET_SYSTEM_NOTES,
    systemNotes,
});



// WEBPACK FOOTER //
// ./src/containers/common/solar/actions.js